import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TestPlanStatus } from '../../../models/test-plan.model';

@Component({
  selector: 'app-plan-status-pill',
  imports: [TranslatePipe],
  templateUrl: './plan-status-pill.component.html',
  styleUrl: './plan-status-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanStatusPillComponent {
  readonly value = input.required<TestPlanStatus>();

  readonly modifier = computed(() => this.value().toLowerCase());
  readonly labelKey = computed(() => 'testPlans.status.' + this.value());
}
